export const illustrationGuideSections = ['ai-character', 'ai-outfit', 'ai-theme', 'ai-scene', 'ai-signature', 'ai-abstraction', 'ai-random', 'ai-extensibility'] as const;
export const guideSections = ['about', 'search', 'viewing', 'favorites', 'articles', 'works', 'sharing', 'usage', 'ratings', 'twitch', 'tools', 'ai-illustrations', ...illustrationGuideSections, 'contact'] as const;
export type GuideSection = typeof guideSections[number];
export const guideTopics = {
    guide: 'about', menu: 'about', 'article-sidebar': 'articles',
    'search-dialog': 'search',
    'image-detail': 'viewing', 'image-data': 'viewing', 'image-prompt': 'viewing', 'image-zoom': 'viewing',
    'favorite-save': 'favorites', 'collection-create': 'favorites', 'collection-manage': 'favorites',
    'image-share': 'sharing', 'work-detail': 'works', 'work-sidebar': 'works',
} as const;
export type GuideTopic = keyof typeof guideTopics;
export type GuideHelpId = GuideSection | GuideTopic;
export const attributeGuideSections: Partial<Record<string, GuideHelpId>> = {
    character: 'ai-character', outfit: 'ai-outfit', theme: 'ai-theme', scene: 'ai-scene',
    signature: 'ai-signature', abstraction: 'ai-abstraction', rating: 'ratings',
};
export const guideHelpEvent = 'site-front:guide-help';
export const isGuideTopic = (id: string): id is GuideTopic => Object.prototype.hasOwnProperty.call(guideTopics, id);
export const guideSection = (id: string): GuideSection => isGuideTopic(id) ? guideTopics[id]
    : id.startsWith('tool-') ? 'tools' : guideSections.includes(id as GuideSection) ? id as GuideSection : 'about';
export function openGuideHelp(id: GuideHelpId, source?: 'gallery-float') {
    window.dispatchEvent(new CustomEvent(guideHelpEvent, { detail: source ? { id, source } : id }));
}
